const COLORS = {
    blue: '#3C94F2',
    indigo: '#30349F',
    purple: '#634D9D',
    pink: '#E83E8C',
    orange: '#F0AD4E',
    cyan: '#5BC0DE',
    lime: '#E0FF66',
    white: '#FFFFFF',
    black: '#000000',
    deepBlue: '#0C3366',
    lightBlue: '#F6FCFF',
    softPink: '#FDC7C5',
    blue500: '#3C94F2',
    blue800: '#1267CE',
    red50: '#FFECEF',
    red100: '#FECFD4',
    red700: '#D53E39',
    red: '#D53E39',
    red800: '#BB302C',
    yellow50: '#FFF8E1',
    yellow75: '#FFF4CF',
    yellow100: '#FFECB3',
    yellow200: '#FFE082',
    lightYellow: '#FFE082',
    yellow500: '#FFC107',
    yellow900: '#F56A00',
    yellow: '#FFC107',
    green50: '#E7F4E7',
    green100: '#C5E5C5',
    green600: '#339C37',
    green800: '#1B7921',
    teal50: '#DFF6ED',
    teal500: '#20CC99',
    teal600: '#1BAF83',
    teal: '#20CC99',
    teal800: '#127457',
    gray50: '#FAFAFA',
    gray100: '#F3F6F9',
    gray150: '#EDF1F6',
    gray200: '#EAEEF5',
    gray250: '#E3E9F2',
    gray300: '#DAE0EB',
    gray400: '#C5CEDE',
    gray500: '#A8B2C4',
    gray600: '#8A94A6',
    gray700: '#697384',
    gray750: '#5B6270',
    gray800: '#474D58',
    gray850: '#363C46',
    gray900: '#242E33',
    primitiveLightSapphire: '#A8BAD9',
    primitiveColorText: '#1D232E',
    primitiveColorSecondaryText: '#0F264D',
    primitiveNavyBlue: '#204C95',
};
const COLORS_WITH_OPACITY = {
    lightSapphire: 'rgba(168, 186, 217, 0.4)',
    colorText: 'rgba(29, 35, 46, 0.88)',
    colorSecondaryText: 'rgba(15, 38, 77, 0.48)',
    navyBlue: 'rgba(32, 76, 149, 0.88)',
};
const THEME_COLORS = {
    primary: COLORS.blue,
    danger: COLORS.red,
    warning: COLORS.yellow,
    success: COLORS.teal600,
    lime: COLORS.lime,
    purple: COLORS.purple,
    white: COLORS.white,
};
export { COLORS, THEME_COLORS, COLORS_WITH_OPACITY };
//# sourceMappingURL=index.js.map